import React from "react";
import { defineMessages } from "react-intl";
import "@mui/material";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityClient, withDataGridEntityServer } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import { MuiDataGridServer } from "../../../components/data-grid/mui/MuiDataGridServer.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import { renderCurrencyCellWithEmptyCheck, renderAmountCurrencyCellWithTooltip, Currency } from "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import { renderCellWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import { renderLabelsCell, labelCellValueGetter } from "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader, renderMuiGridLocalizedTextCell } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import { renderChipCell, renderDefaultChipCell } from "../../../components/data-grid/mui/cells/ChipCell.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import { renderTextListWithTooltipCell } from "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { FeatureAccessStatusTypeName, AccountVerificationStatusTypeName } from "../../../contract/constants.js";
import { UserAccountStatus, FeatureAccessStatus, Platform, Channel } from "../../../contract/pam.js";
import { licenseLocalized } from "../../brand-license/constants.js";
import "@automapper/core";
import "../../../auto-mapper/AutoMapperProvider.js";
import "typesafe-actions";
import "rxjs";
import "redux-observable";
import "../../../api/types.js";
import { isStringNullOrEmpty } from "../../../utils/string.js";
import { formatTimestamp } from "../../../utils/date.js";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import { BrandCircle } from "../../brand-license/components/BrandCircle.js";
import { ChannelTypeName, UserAccountStatusTypeName } from "../constants.js";
import { renderP2PStatusCell } from "./P2PStatusCell.js";
import { UserPlatform } from "./Platform.js";
import { ReferralLinkButton } from "./ReferralLinkButton.js";
const gridUserProfileLocalizedMessages = defineMessages({
  uid: {
    id: "DataGridUserProfile_uid",
    defaultMessage: "UID"
  },
  uid_link_player_details: {
    id: "DataGridUserProfile_uid_link_player_details",
    defaultMessage: "Player ID"
  },
  uid_link_agent_details: {
    id: "DataGridUserProfile_uid_link_agent_details",
    defaultMessage: "Agent ID"
  },
  full_name: {
    id: "DataGridUserProfile_fullName",
    defaultMessage: "Name"
  },
  nickname: {
    id: "DataGridUserProfile_nickname",
    defaultMessage: "Nickname"
  },
  networks_PKW: {
    id: "DataGridUserProfile_cashGamesId",
    defaultMessage: "Cash Game ID"
  },
  networks_BL: {
    id: "DataGridUserProfile_tournamentsId",
    defaultMessage: "Tournaments ID"
  },
  account_status: {
    id: "DataGridUserProfile_accountStatus",
    defaultMessage: "Account Status"
  },
  deposit_status: {
    id: "DataGridUserProfile_depositStatus",
    defaultMessage: "Deposit Lock"
  },
  withdrawal_status: {
    id: "DataGridUserProfile_withdrawalStatus",
    defaultMessage: "Withdrawal Lock"
  },
  p2p_transfer_status: {
    id: "DataGridUserProfile_p2pTransferStatus",
    defaultMessage: "P2P Transfer Lock"
  },
  security_cases: {
    id: "DataGridUserProfile_securityCase",
    defaultMessage: "Security Case ID"
  },
  email: {
    id: "DataGridUserProfile_email",
    defaultMessage: "Email"
  },
  register_marketing_code: {
    id: "DataGridUserProfile_marketingCode",
    defaultMessage: "Marketing Code"
  },
  referrer: {
    id: "DataGridUserProfile_referrer",
    defaultMessage: "Referrer"
  },
  platform: {
    id: "DataGridUserProfile_platform",
    defaultMessage: "Platform"
  },
  national_id: {
    id: "DataGridUserProfile_nationalId",
    defaultMessage: "National ID"
  },
  kyc_status: {
    id: "DataGridUserProfile_kycStatus",
    defaultMessage: "KYC Status"
  },
  phone: {
    id: "DataGridUserProfile_Phone",
    defaultMessage: "Phone number"
  },
  referrer_player_id: {
    id: "DataGridUserProfile_ReferrerPlayerId",
    defaultMessage: "Referral ID"
  },
  referrer_username: {
    id: "DataGridUserProfile_referrerUsername",
    defaultMessage: "Referral Username"
  },
  referred_date: {
    id: "DataGridUserProfile_referredDate",
    defaultMessage: "Referred Date"
  },
  username: {
    id: "DataGridUserProfile_username",
    defaultMessage: "Username"
  },
  balance: {
    id: "DataGridUserProfile_balance",
    defaultMessage: "Balance"
  },
  latest_kyc_security_account_verification_status: {
    id: "DataGridUserProfile_securityKYCStatus",
    defaultMessage: "Security KYC Status"
  },
  latest_kyc_payment_account_verification_status: {
    id: "DataGridUserProfile_paymentKYCStatus",
    defaultMessage: "Payment KYC Status"
  },
  withdrawal_approved_amount: {
    id: "DataGridUserProfile_approvedWithdrawal",
    defaultMessage: "Total Approved Withdrawal"
  },
  withdrawal_approved_count: {
    id: "DataGridUserProfile_approvedWithdrawalCount",
    defaultMessage: "Total Approved Withdrawal Count"
  },
  withdrawal_pending_amount: {
    id: "DataGridUserProfile_pendingWithdrawal",
    defaultMessage: "Total Pending Withdrawal"
  },
  first_name: {
    id: "DataGridUserProfile_firstName",
    defaultMessage: "First Name"
  },
  labels: {
    id: "DataGridUserProfile_labels",
    defaultMessage: "Label"
  },
  latest_login: {
    id: "DataGridUserProfile_latestLogin",
    defaultMessage: "Last login date/time"
  },
  last_name: {
    id: "DataGridUserProfile_lastName",
    defaultMessage: "Last Name"
  },
  date_of_joining: {
    id: "DataGridUserProfile_dateOfJoining",
    defaultMessage: "Registration Date"
  },
  country: {
    id: "DataGridUserProfile_country",
    defaultMessage: "Country"
  },
  deposit_total: {
    id: "DataGridUserProfile_depositTotal",
    defaultMessage: "Total Deposits"
  },
  "agent_info.latest_revenue_share.casino_share": {
    id: "DataGridUserProfile_agentInfoLatestRevenueShareCasinoShare",
    defaultMessage: "Casino %"
  },
  "agent_info.latest_revenue_share.spins": {
    id: "DataGridUserProfile_agentInfoLatestRevenueShare_spins",
    defaultMessage: "Global Spins %"
  },
  "agent_info.latest_revenue_share.poker_mtt": {
    id: "DataGridUserProfile_agentInfoLatestRevenueSharePokerMtt",
    defaultMessage: "MTT %"
  },
  "agent_info.latest_revenue_share.sports": {
    id: "DataGridUserProfile_agentInfoLatestRevenueShareSports",
    defaultMessage: "Sports %"
  },
  "agent_info.latest_revenue_share.poker_cash.plo": {
    id: "DataGridUserProfile_agentInfoLatestRevenueSharePokerCashPlo",
    defaultMessage: "PLO %"
  },
  "agent_info.latest_revenue_share.poker_cash.nlh_sd": {
    id: "DataGridUserProfile_agentInfoLatestRevenueSharePokerCashNlhSd",
    defaultMessage: "Poker %"
  },
  login_countries: {
    id: "DataGridUserProfile_loginCountries",
    defaultMessage: "Login Countries"
  },
  brand: {
    id: "DataGridUserProfile_brand",
    defaultMessage: "Brand"
  },
  license_type: {
    id: "DataGridUserProfile_licenseType",
    defaultMessage: "License Type"
  },
  withdrawal_total_pending_count: {
    id: "DataGridUserProfile_withdrawalPendingCount",
    defaultMessage: "Pending Count"
  },
  casino_coin_balance: {
    id: "DataGridUserProfile_casinoCoinBalance",
    defaultMessage: "Casino Coin"
  },
  casino_ggr_lifetime: {
    id: "DataGridUserProfile_casinoGgrLifetime",
    defaultMessage: "Casino GGR"
  },
  poker_ggr_lifetime: {
    id: "DataGridUserProfile_pokerGgrLifetime",
    defaultMessage: "Poker GGR"
  },
  sports_ggr_lifetime: {
    id: "DataGridUserProfile_sportsGgrLifetime",
    defaultMessage: "Sportsbook GGR"
  },
  withdrawal_total: {
    id: "DataGridUserProfile_withdrawalTotal",
    defaultMessage: "Total Withdrawals"
  },
  withdrawable_balance: {
    id: "DataGridUserProfile_withdrawableBalance",
    defaultMessage: "Withdrawable Balance"
  },
  channel: {
    id: "DataGridUserProfile_channel",
    defaultMessage: "Channel"
  },
  aal: {
    id: "DataGridUserProfile_aal",
    defaultMessage: "AAL"
  },
  personalReferralCode: {
    id: "DataGridUserProfile_personalReferralCode",
    defaultMessage: "Referral Code"
  },
  copyReferralLink: {
    id: "DataGridUserProfile_copyReferralLink",
    defaultMessage: "Referral Link"
  }
});
const gridUserProfileLocalizedHeaders = {
  uid: gridUserProfileLocalizedMessages.uid,
  uid_link_cs: gridUserProfileLocalizedMessages.uid,
  uid_link_agent: gridUserProfileLocalizedMessages.uid,
  uid_link_security: gridUserProfileLocalizedMessages.uid,
  uid_link_player_details: gridUserProfileLocalizedMessages.uid_link_player_details,
  uid_link_agent_details: gridUserProfileLocalizedMessages.uid_link_agent_details,
  full_name: gridUserProfileLocalizedMessages.full_name,
  nickname: gridUserProfileLocalizedMessages.nickname,
  networks_PKW: gridUserProfileLocalizedMessages.networks_PKW,
  networks_BL: gridUserProfileLocalizedMessages.networks_BL,
  account_status: gridUserProfileLocalizedMessages.account_status,
  deposit_status: gridUserProfileLocalizedMessages.deposit_status,
  withdrawal_status: gridUserProfileLocalizedMessages.withdrawal_status,
  p2p_transfer_status: gridUserProfileLocalizedMessages.p2p_transfer_status,
  p2p_status: gridUserProfileLocalizedMessages.p2p_transfer_status,
  security_cases: gridUserProfileLocalizedMessages.security_cases,
  email: gridUserProfileLocalizedMessages.email,
  register_marketing_code: gridUserProfileLocalizedMessages.register_marketing_code,
  referrer: gridUserProfileLocalizedMessages.referrer,
  platform: gridUserProfileLocalizedMessages.platform,
  platform_narrow: gridUserProfileLocalizedMessages.platform,
  national_id: gridUserProfileLocalizedMessages.national_id,
  "latest_kyc.payment.account_verification_status": gridUserProfileLocalizedMessages.kyc_status,
  phone: gridUserProfileLocalizedMessages.phone,
  referrer_player_id: gridUserProfileLocalizedMessages.referrer_player_id,
  referrer_username: gridUserProfileLocalizedMessages.referrer_username,
  referred_date: gridUserProfileLocalizedMessages.referred_date,
  username: gridUserProfileLocalizedMessages.username,
  "finance.balance": gridUserProfileLocalizedMessages.balance,
  "latest_kyc.security.account_verification_status": gridUserProfileLocalizedMessages.latest_kyc_security_account_verification_status,
  "latest_kyc.payment.account_verification_status_cs": gridUserProfileLocalizedMessages.latest_kyc_payment_account_verification_status,
  withdrawal_approved_amount: gridUserProfileLocalizedMessages.withdrawal_approved_amount,
  withdrawal_approved_count: gridUserProfileLocalizedMessages.withdrawal_approved_count,
  withdrawal_pending_amount: gridUserProfileLocalizedMessages.withdrawal_pending_amount,
  first_name: gridUserProfileLocalizedMessages.first_name,
  labels: gridUserProfileLocalizedMessages.labels,
  "latest_login.logged_at_ts.seconds": gridUserProfileLocalizedMessages.latest_login,
  last_name: gridUserProfileLocalizedMessages.last_name,
  "phone.area": null,
  "phone.number": null,
  "birthday.seconds": null,
  gender: null,
  "date_of_joining.seconds": gridUserProfileLocalizedMessages.date_of_joining,
  is_2fa_enabled: null,
  is_challenge_questions_enabled: null,
  country: gridUserProfileLocalizedMessages.country,
  lobby_access_status: null,
  "security_cases.type": null,
  "security_cases.case_id": null,
  "security_cases.closed_at": null,
  "security_cases.opened_at": null,
  "latest_kyc.security.id": null,
  deposit_total: gridUserProfileLocalizedMessages.deposit_total,
  balance: null,
  ggr: null,
  lifetime_bonus: null,
  bonus_ratio: null,
  "agent_info.is_agent": null,
  "agent_info.default_agent_revenue_share_history": null,
  "agent_info.latest_revenue_share.casino_share": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.casino_share"],
  "agent_info.latest_revenue_share.spins": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.spins"],
  "agent_info.latest_revenue_share.poker_mtt": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.poker_mtt"],
  "agent_info.latest_revenue_share.sports": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.sports"],
  "agent_info.latest_revenue_share.poker_cash.plo": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.poker_cash.plo"],
  "agent_info.latest_revenue_share.poker_cash.nlh_sd": gridUserProfileLocalizedMessages["agent_info.latest_revenue_share.poker_cash.nlh_sd"],
  casino_status: null,
  sportsbook_status: null,
  "referral.personal_referral_link": null,
  "latest_kyc.payment.id": null,
  "networks.uid": null,
  "networks.platform": null,
  aml_labels: null,
  login_countries: gridUserProfileLocalizedMessages.login_countries,
  vpn: null,
  brand: gridUserProfileLocalizedMessages.brand,
  license_type: gridUserProfileLocalizedMessages.license_type,
  "finance.withdrawal.total.pending_count": gridUserProfileLocalizedMessages.withdrawal_total_pending_count,
  "finance.casino_coin_balance": gridUserProfileLocalizedMessages.casino_coin_balance,
  "finance.p2p_credit.successful_amount": null,
  "finance.p2p_debit.successful_amount": null,
  casino_ggr_lifetime: gridUserProfileLocalizedMessages.casino_ggr_lifetime,
  poker_ggr_lifetime: gridUserProfileLocalizedMessages.poker_ggr_lifetime,
  sports_ggr_lifetime: gridUserProfileLocalizedMessages.sports_ggr_lifetime,
  withdrawal_total: gridUserProfileLocalizedMessages.withdrawal_total,
  "finance.withdrawable_balance": gridUserProfileLocalizedMessages.withdrawable_balance,
  aal: gridUserProfileLocalizedMessages.aal,
  channel: gridUserProfileLocalizedMessages.channel,
  "referral.personal_referral_code": gridUserProfileLocalizedMessages.personalReferralCode,
  copyReferralLink: gridUserProfileLocalizedMessages.copyReferralLink
};
class DataGridUserProfileConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      uid: {
        field: "uid",
        valueGetter: (_, row) => this.getUid(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.uid,
        renderCell: renderDefaultChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      full_name: {
        field: "full_name",
        valueGetter: (_, row) => this.getFullName(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.full_name,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      nickname: {
        field: "nickname",
        valueGetter: (_, row) => this.getNickname(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.nickname,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      platform: {
        field: "platform",
        valueGetter: (_, row) => this.getPlatform(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.platform,
        renderCell: (params) => /* @__PURE__ */ React.createElement(UserPlatform, { value: params.value }),
        sortable: false,
        flex: 0.2,
        width: 200
      },
      brand: {
        field: "brand",
        valueGetter: (_, row) => this.getBrand(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.brand,
        renderCell: (params) => /* @__PURE__ */ React.createElement(BrandCircle, { value: params.value }),
        sortable: false,
        flex: 0.15,
        width: 100
      },
      license_type: {
        field: "license_type",
        valueGetter: (_, row) => this.getLicenseType(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.license_type,
        renderCell: renderMuiGridLocalizedTextCell,
        sortable: true,
        flex: 0.1,
        width: 100
      },
      platform_narrow: {
        field: "platform_narrow",
        valueGetter: (_, row) => this.getPlatform(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.platform_narrow,
        renderCell: (params) => /* @__PURE__ */ React.createElement(UserPlatform, { value: params.value }),
        sortable: false,
        flex: 0.1,
        width: 100
      },
      account_status: {
        field: "account_status",
        valueGetter: (_, row) => this.getChipValue(this.getAccountStatus(row), UserAccountStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.account_status,
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      withdrawal_status: {
        field: "withdrawal_status",
        valueGetter: (_, row) => this.getChipValue(this.getWithdrawalStatus(row), FeatureAccessStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.withdrawal_status,
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      deposit_status: {
        field: "deposit_status",
        valueGetter: (_, row) => this.getChipValue(this.getDepositStatus(row), FeatureAccessStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.deposit_status,
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      "latest_kyc.payment.account_verification_status": {
        field: "latest_kyc.payment.account_verification_status",
        valueGetter: (_, row) => this.getChipValue(this.getLatestPaymentAccountVerificationStatus(row), AccountVerificationStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["latest_kyc.payment.account_verification_status"],
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.15,
        width: 150
      },
      "latest_kyc.payment.account_verification_status_cs": {
        field: "latest_kyc.payment.account_verification_status_cs",
        valueGetter: (_, row) => this.getChipValue(this.getLatestPaymentAccountVerificationStatus(row), AccountVerificationStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["latest_kyc.payment.account_verification_status_cs"],
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.11,
        width: 110
      },
      "latest_kyc.security.account_verification_status": {
        field: "latest_kyc.security.account_verification_status",
        valueGetter: (_, row) => this.getChipValue(this.getSecurityKycStatus(row), AccountVerificationStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["latest_kyc.security.account_verification_status"],
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.11,
        width: 110
      },
      phone: {
        field: "phone",
        valueGetter: (_, row) => this.getPhone(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.phone,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.12,
        width: 120
      },
      referrer_player_id: {
        field: "referrer_player_id",
        valueGetter: (_, row) => this.getReferrerPlayerId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.referrer_player_id,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      referrer_username: {
        field: "referrer_username",
        valueGetter: (_, row) => this.getReferrerUsername(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.referrer_username,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      referred_date: {
        field: "referred_date",
        valueGetter: (_, row) => this.getReferredDate(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.referred_date,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      email: {
        field: "email",
        valueGetter: (_, row) => this.getEmail(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.email,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.14,
        width: 140
      },
      username: {
        field: "username",
        valueGetter: (_, row) => this.getUsername(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.username,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      "finance.balance": {
        field: "finance.balance",
        valueGetter: (_, row) => this.getBalance(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["finance.balance"],
        renderCell: renderAmountCurrencyCellWithTooltip,
        sortable: true,
        flex: 0.1,
        width: 100
      },
      p2p_transfer_status: {
        field: "p2p_transfer_status",
        valueGetter: (_, row) => this.getChipValue(this.getP2PTransferStatus(row), FeatureAccessStatusTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.p2p_transfer_status,
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      register_marketing_code: {
        field: "register_marketing_code",
        valueGetter: (_, row) => this.getMarketingCode(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.register_marketing_code,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      referrer: {
        field: "referrer",
        valueGetter: (_, row) => this.getReferrer(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.referrer,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      labels: {
        field: "labels",
        valueGetter: (_, row) => this.getLabels(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.labels,
        renderCell: renderLabelsCell,
        sortable: false,
        flex: 0.17,
        width: 170
      },
      national_id: {
        field: "national_id",
        valueGetter: (_, row) => this.getNationalId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.national_id,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      networks_PKW: {
        field: "networks_PKW",
        valueGetter: (_, row) => this.getCashGamesId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.networks_PKW,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.11,
        width: 110
      },
      networks_BL: {
        field: "networks_BL",
        valueGetter: (_, row) => this.getTournamentsId(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.networks_BL,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.11,
        width: 110
      },
      withdrawal_approved_amount: {
        field: "withdrawal_approved_amount",
        valueGetter: (_, row) => this.getApprovedWithdrawalAmount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.withdrawal_approved_amount,
        renderCell: renderAmountCurrencyCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      withdrawal_approved_count: {
        field: "withdrawal_approved_count",
        valueGetter: (_, row) => this.getApprovedWithdrawalCount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.withdrawal_approved_count,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.12,
        width: 120
      },
      withdrawal_pending_amount: {
        field: "withdrawal_pending_amount",
        valueGetter: (_, row) => this.getPendingWithdrawalAmount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.withdrawal_pending_amount,
        renderCell: renderAmountCurrencyCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 150
      },
      "latest_login.logged_at_ts.seconds": {
        field: "latest_login.logged_at_ts.seconds",
        valueGetter: (_, row) => this.getLastLogin(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["latest_login.logged_at_ts.seconds"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.25,
        width: 250
      },
      country: {
        field: "country",
        valueGetter: (_, row) => this.getCountry(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.country,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      first_name: {
        field: "first_name",
        valueGetter: (_, row) => this.getFirstName(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.first_name,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 150
      },
      last_name: {
        field: "last_name",
        valueGetter: (_, row) => this.getLastName(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.last_name,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 150
      },
      "date_of_joining.seconds": {
        field: "date_of_joining.seconds",
        valueGetter: (_, row) => this.getDateOfJoining(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["date_of_joining.seconds"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.2,
        width: 200
      },
      login_countries: {
        field: "login_countries",
        valueGetter: (_, row) => this.getCountries(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.login_countries,
        renderCell: renderTextListWithTooltipCell,
        sortable: false,
        flex: 0.12,
        width: 130
      },
      "finance.withdrawal.total.pending_count": {
        field: "finance.withdrawal.total.pending_count",
        valueGetter: (_, row) => this.getWithdrawalPendingCount(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["finance.withdrawal.total.pending_count"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      deposit_total: {
        field: "deposit_total",
        valueGetter: (_, row) => this.getDepositTotal(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.deposit_total,
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      withdrawal_total: {
        field: "withdrawal_total",
        valueGetter: (_, row) => this.getWithdrawalTotal(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.withdrawal_total,
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      casino_ggr_lifetime: {
        field: "casino_ggr_lifetime",
        valueGetter: (_, row) => this.getCasinoGgrLifetime(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.casino_ggr_lifetime,
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      poker_ggr_lifetime: {
        field: "poker_ggr_lifetime",
        valueGetter: (_, row) => this.getPokerGgrLifetime(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.poker_ggr_lifetime,
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      sports_ggr_lifetime: {
        field: "sports_ggr_lifetime",
        valueGetter: (_, row) => this.getSportsGgrLifetime(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.sports_ggr_lifetime,
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "finance.casino_coin_balance": {
        field: "finance.casino_coin_balance",
        valueGetter: (_, row) => this.getCCBalance(row),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["finance.casino_coin_balance"],
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      "agent_info.latest_revenue_share.casino_share": {
        field: "agent_info.latest_revenue_share.casino_share",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.casino_share;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.casino_share"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "agent_info.latest_revenue_share.spins": {
        field: "agent_info.latest_revenue_share.spins",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.spins;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.spins"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "agent_info.latest_revenue_share.poker_mtt": {
        field: "agent_info.latest_revenue_share.poker_mtt",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.poker_mtt;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.poker_mtt"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "agent_info.latest_revenue_share.sports": {
        field: "agent_info.latest_revenue_share.sports",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.sports;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.sports"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "agent_info.latest_revenue_share.poker_cash.plo": {
        field: "agent_info.latest_revenue_share.poker_cash.plo",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.poker_cash?.plo;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.poker_cash.plo"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      "agent_info.latest_revenue_share.poker_cash.nlh_sd": {
        field: "agent_info.latest_revenue_share.poker_cash.nlh_sd",
        valueGetter: (_, row) => {
          return row?.latest_revenue_share?.poker_cash?.nlh_sd;
        },
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["agent_info.latest_revenue_share.poker_cash.nlh_sd"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15,
        width: 140
      },
      channel: {
        field: "channel",
        valueGetter: (_, row) => this.getChipValue(row?.channel ?? Channel.None, ChannelTypeName),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.channel,
        renderCell: renderChipCell,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      aal: {
        field: "aal",
        valueGetter: (_, row) => row?.aal?.join(", "),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.aal,
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      "referral.personal_referral_code": {
        field: "referral.personal_referral_code",
        valueGetter: (_, row) => row?.referral?.personal_referral_code,
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["referral.personal_referral_code"],
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.1,
        width: 100
      },
      copyReferralLink: {
        field: "copyReferralLink",
        valueGetter: (_, row) => ({ referralCode: row?.referral?.personal_referral_code, uid: row.uid }),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders.copyReferralLink,
        renderCell: (props) => /* @__PURE__ */ React.createElement(ReferralLinkButton, { uid: props.value?.uid, personalReferralCode: props.value?.referralCode }),
        sortable: false,
        flex: 0.15,
        width: 150
      },
      "finance.withdrawable_balance": {
        field: "finance.withdrawable_balance",
        valueGetter: (_, row) => ({ amount: row?.finance?.withdrawable_balance, currency: row?.currency }),
        renderHeader: renderCellHeader,
        localizedHeaderName: gridUserProfileLocalizedHeaders["finance.withdrawable_balance"],
        renderCell: renderCurrencyCellWithEmptyCheck,
        sortable: false,
        flex: 0.15,
        width: 140
      }
    };
    return columnsMapping;
  }
  getP2PStatusColumn(entityType) {
    return {
      field: "p2p_status",
      valueGetter: (_, row) => this.getP2PStatus(row, entityType),
      renderHeader: renderCellHeader,
      localizedHeaderName: gridUserProfileLocalizedHeaders.p2p_status,
      renderCell: renderP2PStatusCell,
      sortable: false,
      flex: 0.1,
      width: 100
    };
  }
  getCCBalance(model) {
    return { amount: model?.finance?.casino_coin_balance, currency: Currency.CasinoCoin };
  }
  getSportsGgrLifetime(model) {
    return { amount: model?.finance?.ggr_lifetime?.sports, currency: model?.currency };
  }
  getPokerGgrLifetime(model) {
    return { amount: model?.finance?.ggr_lifetime?.poker, currency: model?.currency };
  }
  getCasinoGgrLifetime(model) {
    return { amount: model?.finance?.ggr_lifetime?.casino, currency: model?.currency };
  }
  getDepositTotal(model) {
    return { amount: model?.finance?.deposit?.total?.successful_amount, currency: model?.currency };
  }
  getWithdrawalTotal(model) {
    return { amount: model?.finance?.withdrawal?.total?.successful_amount, currency: model?.currency };
  }
  getUid(model) {
    return model?.uid;
  }
  getCountries(model) {
    return model?.countries;
  }
  getDateOfJoining(model) {
    return formatTimestamp(model?.date_of_joining, "date-time-with-seconds");
  }
  getFirstName(model) {
    return model?.first_name;
  }
  getLastName(model) {
    return model?.last_name;
  }
  getLastLogin(model) {
    return formatTimestamp(model?.latest_login?.logged_at_ts, "date-time-with-seconds");
  }
  getNickname(model) {
    return model?.nickname;
  }
  getFullName(model) {
    return model.first_name || model.last_name ? `${model.first_name} ${model.last_name}` : null;
  }
  getAccountStatus(model) {
    return model?.account_status ?? UserAccountStatus.Active;
  }
  getWithdrawalStatus(model) {
    return model?.withdrawal_status ?? FeatureAccessStatus.Unlocked;
  }
  getDepositStatus(model) {
    return model?.deposit_status ?? FeatureAccessStatus.Unlocked;
  }
  getPlatform(model) {
    return model?.platform;
  }
  getBrand(model) {
    return model?.brand;
  }
  getLicenseType(model) {
    return model?.license_type ? licenseLocalized[model?.license_type] : void 0;
  }
  getLatestPaymentAccountVerificationStatus(model) {
    return model?.latest_kyc?.payment?.account_verification_status;
  }
  getPhone(model) {
    return model?.contact?.mobile?.full_number;
  }
  getReferrerPlayerId(model) {
    return model?.referral?.inviting_user_id;
  }
  getReferrerUsername(model) {
    return model?.referral?.inviting_user_username;
  }
  getReferredDate(model) {
    return formatTimestamp(model?.referral?.referred_at, "date");
  }
  getEmail(model) {
    return model?.contact?.email;
  }
  getUsername(model) {
    return model?.username;
  }
  getBalance(model) {
    return { amount: model?.finance?.balance, currency: model?.currency };
  }
  getP2PTransferStatus(model) {
    return model?.p2p_transfer_status;
  }
  getP2PStatus(model, entityType) {
    return {
      type: model?.p2p_override_status ? "Personal" : "Global",
      personalLockStatus: model?.p2p_status,
      uid: model?.uid,
      entityType
    };
  }
  getMarketingCode(model) {
    return model?.marketing_info?.register_marketing_code;
  }
  getReferrer(model) {
    const btag = model?.affiliate?.btag;
    return !isStringNullOrEmpty(btag) ? btag : model?.referral?.inviting_user_id;
  }
  getLabels(model) {
    return labelCellValueGetter(model?.labels);
  }
  getNationalId(model) {
    return model?.region_player_info?.national_id;
  }
  getSecurityKycStatus(model) {
    return model?.latest_kyc?.security?.account_verification_status;
  }
  getCashGamesId(model) {
    return model?.networks?.find((item) => item.platform === Platform.Pkw)?.uid;
  }
  getTournamentsId(model) {
    return model?.networks?.find((item) => item.platform === Platform.Bl)?.uid;
  }
  getApprovedWithdrawalAmount(model) {
    return { amount: model?.finance?.withdrawal?.total?.successful_amount, currency: model?.currency };
  }
  getApprovedWithdrawalCount(model) {
    return model?.finance?.withdrawal?.total?.successful_count;
  }
  getPendingWithdrawalAmount(model) {
    return { amount: model?.finance?.withdrawal?.total?.pending_amount, currency: model?.currency };
  }
  getCountry(model) {
    return model?.address?.country_info?.iso_alpha2_code;
  }
  getWithdrawalPendingCount(model) {
    return model?.finance?.withdrawal?.total?.pending_count;
  }
}
const DataGridUserProfileClient = withDataGridEntityClient(
  MuiDataGridClient,
  () => new DataGridUserProfileConfigFactory().getColumnConfig()
);
const DataGridUserProfileServer = withDataGridEntityServer(
  MuiDataGridServer,
  () => new DataGridUserProfileConfigFactory().getColumnConfig()
);
export {
  DataGridUserProfileClient,
  DataGridUserProfileConfigFactory,
  DataGridUserProfileServer,
  gridUserProfileLocalizedHeaders
};
//# sourceMappingURL=DataGrid.js.map
